import { Component, Input, TemplateRef } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "vw-select",
  templateUrl: "./select.component.html",
})
export class SelectComponent {
  @Input() label?: string;
  @Input() id?: string;
  @Input() items?: any[];
  @Input() template?: TemplateRef<any>;
  @Input() formControlProp?: string | number;
  @Input({ required: true }) parentForm!: FormGroup;
  @Input() emptyOption?: boolean;

  constructor() {}
}
